<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link class="flex text-indigo-400 group-hover:text-indigo-600" :href="route('campaigns')">
        <icon name="store-front" class="w-6 mr-3 fill-indigo-400 group-hover:fill-indigo-600" /> Campanhas /
      </inertia-link>
      <span class="ml-1 font-medium">
        Criar
      </span>
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-if="showOrganizations" v-model="form.organization_id" :error="form.errors.organization_id" class="pr-6 pb-8 w-full" label="Organização">
            <option :value="null" />
            <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
          </select-input>
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full " label="Nome" />
          <text-input v-model="form.label" :error="form.errors.label" class="pr-6 pb-8 w-full " label="Título da Ação" />
          <!-- <textarea-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-8 w-full " label="Descrição" /> -->
          <label class="pr-6 w-full" for="description" :error="form.errors.description">
            Descrição: <small v-if="form.errors.description" class="form-error">{{ form.errors.description }}</small>
          </label>
          <v-md-editor
            id="description"
            v-model="form.description"
            left-toolbar="undo redo clear | h bold italic strikethrough quote | ul ol table hr | link code"
            right-toolbar="preview sync-scroll"
            class="form-input mt-3 mr-6 mb-8 w-full"
            :class="{ 'error': form.errors.description }"
            height="400px"
          />
          <text-input v-model="form.url" :error="form.errors.url" class="pr-6 pb-8 w-full " placeholder="Ex.: https://www.google.com" label="URL" />
          <text-input v-model="form.coordinates" :error="form.errors.coordinates" class="pr-6 pb-8 w-full " placeholder="Ex.: -30.106952816533454,-51.31577000218502,200" label="Coordenadas (Lat long)" :class="{ 'hidden': !showOrganizations }" />
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <text-input v-model="form.major" :error="form.errors.major" class="pr-6 pb-8 w-full " label="Major (Beacon)" :class="{ 'hidden': !showOrganizations }" />
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <text-input v-model="form.minor" :error="form.errors.minor" class="pr-6 pb-8 w-full " label="Minor (Beacon)" :class="{ 'hidden': !showOrganizations }" />
          </div>
          <div class="pr-6 pb-8 w-full ">
            <label>Data Inicial:</label><br /><br />
            <datepicker v-model="form.start_date" :language="ptBR" :error="form.errors.start_date" :format="customFormatter" placeholder="Selecione..." @input="endInOneYear()" />
          </div>
          <div class="pr-6 pb-8 w-full ">
            <label>Data Final:</label><br /><br />
            <datepicker v-model="form.end_date" :language="ptBR" :error="form.errors.end_date" :format="customFormatter" placeholder="Selecione..." />
          </div>
          <div class="pr-6 pb-8 w-full ">
            <label class="mt-6 select-none flex items-center" for="sunday">
              <input id="sunday" v-model="form.sunday" class="mr-1" type="checkbox" />
              <span class="text-sm">Domingo</span>
            </label>
            <label class="mt-6 select-none flex items-center" for="monday">
              <input id="monday" v-model="form.monday" class="mr-1" type="checkbox" />
              <span class="text-sm">Segunda-feira</span>
            </label>
            <label class="mt-6 select-none flex items-center" for="tuesday">
              <input id="tuesday" v-model="form.tuesday" class="mr-1" type="checkbox" />
              <span class="text-sm">Terça-feira</span>
            </label>
            <label class="mt-6 select-none flex items-center" for="wednesday">
              <input id="wednesday" v-model="form.wednesday" class="mr-1" type="checkbox" />
              <span class="text-sm">Quarta-feira</span>
            </label>
            <label class="mt-6 select-none flex items-center" for="thursday">
              <input id="thursday" v-model="form.thursday" class="mr-1" type="checkbox" />
              <span class="text-sm">Quinta-feira</span>
            </label>
            <label class="mt-6 select-none flex items-center" for="friday">
              <input id="friday" v-model="form.friday" class="mr-1" type="checkbox" />
              <span class="text-sm">Sexta-feira</span>
            </label>
            <label class="mt-6 select-none flex items-center" for="saturday">
              <input id="saturday" v-model="form.saturday" class="mr-1" type="checkbox" />
              <span class="text-sm">Sábado</span>
            </label>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Estado:</label>
            <select id="state" v-model="form.state_id" class="form-select" required="required" @change="getCities()">
              <option :value="null" />
              <option v-for="state in states" :key="state.id" :value="state.id">{{ state.name }}</option>
            </select>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Cidade:</label>
            <select id="city" v-model="form.city_id" class="form-select" required="required">
              <option :value="null" />
              <option v-for="city in dataCities" :key="city.id" :value="city.id">{{ city.name }}</option>
            </select>
          </div>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full " type="file" accept="image/*" label="Imagem" />
          <file-input v-model="form.audio" :error="form.errors.audio" class="pr-6 pb-8 w-full " type="file" accept="audio/*" label="Áudio" />
          <select-input v-model="form.active" :error="form.errors.active" class="pr-6 pb-8 w-full " label="Ativo" :class="{ 'hidden': !showOrganizations }" :disabled="!showOrganizations">
            <option :value="null" />
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Criar Campanha</loading-button>
          <span :class="{ 'hidden': !showOrganizations }">&nbsp;ou&nbsp;</span>
          <button class="btn-indigo" type="button" :class="{ 'hidden': !showOrganizations }" @click="storeAndQrcode">Criar Campanha &amp; QRCode</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
// import TextareaInput from '@/Shared/TextareaInput'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'
import {ptBR} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
  // metaInfo: { title: 'Create Campaign' },
  metaInfo: { title: 'Criar Campanha' },
  components: {
    Datepicker,
    // TextareaInput,
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    Icon,
  },
  layout: Layout,
  remember: 'form',
  props: {
    organizations: Array,
    states: Array,
    cities: Array,
    showOrganizations: Boolean,
  },
  data() {
    return {
      dataCities: this.cities,
      ptBR: ptBR,
      form: this.$inertia.form({
        organization_id: null,
        name: null,
        label: null,
        description: '',
        url: null,
        coordinates: null,
        major: null,
        minor: null,
        start_date: new Date(),
        end_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
        photo: null,
        audio: null,
        active: !this.showOrganizations ? true : null,
        city_id: null,
        state_id: null,
        state: null,
      }),
    }
  },
  methods: {
    customFormatter(date) {
      moment.locale('pt-br')
      return moment(date).format('L')
    },
    endInOneYear() {
      this.form.end_date = new Date(new Date(this.form.start_date).setFullYear(this.form.start_date.getFullYear() + 1))
    },
    store() {
      this.form.post(this.route('campaigns.store').url())
    },
    storeAndQrcode() {
      this.form.post(this.route('campaigns.storeAndQrcode').url())
    },
    getCities() {
      if(this.dataCities.length > 0 && this.states.length == 1)
      {
        return
      }

      axios.get(
        this.route('cities'),
        {
          params: {
            stateId: this.form.state_id,
          },
        }).then(
        (response) => {
          this.dataCities = response.data
        })
    },
  },
}
</script>
